import type { EventStatsDto, EventStatsPeriod } from "@mvk/shared";
import { apiRequest } from "../api/client";

export const adminStatsApi = {
  getEventStats(
    eventId: string,
    period: EventStatsPeriod = "event",
    opts?: { nativeTicketsOnly?: boolean },
  ): Promise<{ stats: EventStatsDto }> {
    const params = new URLSearchParams({ period });
    if (opts?.nativeTicketsOnly) params.set("nativeTickets", "1");
    return apiRequest(`/events/${eventId}/stats?${params.toString()}`, {
      audience: "admin",
    });
  },
};
